import { render, staticRenderFns } from "./inventoryStockSummaryWidget.vue?vue&type=template&id=525e457e&"
import script from "./inventoryStockSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryStockSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports